/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * Copyright 2024 - The Norwegian Meteorological Institute (MET Norway)
 * */
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';
import ShortcutList from './ShortcutList';

interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
}: TabPanelProps) => (
  <div
    aria-labelledby={`tab-${index}`}
    hidden={value !== index}
    id={`tabpanel-${index}`}
    role="tabpanel"
  >
    {value === index && children}
  </div>
);

const styles = {
  container: {
    margin: '0px 20px',
    maxHeight: '90vh',
  },
  tab: {
    fontSize: 12,
  },
};

const CheatSheet: React.FC = () => {
  const [activeTab, setActiveTab] = React.useState(0);

  const onChangeTab = (
    _event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={styles.container}>
      <Tabs aria-label="platform" onChange={onChangeTab} value={activeTab}>
        <Tab label="Windows" sx={styles.tab} />
        <Tab label="Mac" sx={styles.tab} />
      </Tabs>
      <TabPanel index={0} value={activeTab}>
        <ShortcutList />
      </TabPanel>
      <TabPanel index={1} value={activeTab}>
        <ShortcutList platform="mac" />
      </TabPanel>
    </Box>
  );
};

export default CheatSheet;
